export const EVENT = 'order';
export const SUBSCRIPTION = 'subscription';
export const CONTRACT = 'contract';

export default Object.freeze({
  EVENT,
  SUBSCRIPTION,
  CONTRACT
});
